module.exports = __webpack_public_path__ + "img/ico-caret.0bd84ec6.svg";